import React from 'react'

import { SideSummaryItem } from './SideSummaryItem/SideSummaryItem'
import * as S from './styled'
import type { Props } from './types'

export const SideSummary = ({ children }: Props) => <S.Container>{children}</S.Container>

SideSummary.Item = SideSummaryItem
SideSummary.Subtitle = S.Subtitle
